export default __webpack_public_path__ + "locales/sr-Cyrl-RS/DataReassignmentDialog.json?hash=e19021b758b60f5e47eca318cb824fed";